@if(keycloakInitialized) {
@if(!isLoggedIn ) {
<vl-button (onClick)="login()" status="primary">
    <vl-icon class="mr-2" icon="user" pack="font-awesome-solid" status="light"></vl-icon>
    <span i18n="@@header.login">Login</span>
</vl-button>
<vl-button (onClick)="register()" status="dark">
    <vl-icon class="mr-2" icon="pen" pack="font-awesome-solid" status="light"></vl-icon>
    <span i18n="@@header.signup">Sign Up</span>
</vl-button>

} @else {
<vl-button (onClick)="goToMyAccount()" status="primary">
    <vl-icon class="mr-2" icon="user" pack="font-awesome-solid" status="light"></vl-icon>
    <span i18n="@@header.myaccount">My account</span>
</vl-button>
<vl-button (onClick)="goToControlPanel()" status="success">
    <vl-icon class="mr-2" icon="cog" pack="font-awesome-solid" status="light"></vl-icon>
    <span i18n="@@header.control_panel">Control Panel</span>
</vl-button>
<vl-button (onClick)="logout()" status="dark">
    <vl-icon class="mr-2" icon="sign-out-alt" pack="font-awesome-solid" status="light"></vl-icon>
    <span i18n="@@header.logout">Logout</span>
</vl-button>
}
}